import { FC } from 'react';
import Image from 'next/image';

import { EMAIL, FB_PAGE } from 'util/const';

import styles from './Footer.module.scss';

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <section className={styles.content}>
        <div className={styles.linksRow}>
          <span>
            <a href={FB_PAGE} target="_blank" rel="noreferrer noopener">
              <Image alt="facebook" src="/images/common/icons/icon-facebook.svg" width="24" height="24" />
            </a>
          </span>
          <span>
            <a
              href="https://medium.com/%E6%88%91%E8%88%87%E8%B3%87%E7%A8%AE-itseed-%E8%B3%87%E8%A8%8A%E7%A8%AE%E5%AD%90-%E5%AE%98%E6%96%B9%E9%83%A8%E8%90%BD%E6%A0%BC"
              target="_blank"
              rel="noreferrer noopener"
            >
              <Image alt="medium" src="/images/common/icons/icon-medium.svg" width="24" height="24" />
            </a>
          </span>
          <span>
            <a href={`mailto:${EMAIL}`} target="_blank" rel="noreferrer noopener">
              <Image alt="mail" src="/images/common/icons/icon-mail.svg" width="24" height="24" />
            </a>
          </span>
        </div>
        <div className={styles.ownerRow}>
          <span>主辦單位：新北市電腦商業同業公會</span>
          <Image alt="NTCA" src="/images/common/icons/NTCA-logo.svg" width="46" height="11" />
        </div>
        <span className={styles.copywritingRow}>Copyright © {new Date().getFullYear()} - 資訊種子培訓計畫</span>
      </section>
    </footer>
  );
};

export default Footer;
